import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("awg_token");
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (url) => {
  if (!url) return url;
  const i = url.indexOf("/api/files/");
  if (i >= 0) return `${BACKEND}${url.slice(i)}`;
  if (url.startsWith("http")) {
    if (url.includes("static.prod-images.emergentagent.com") || url.includes("images.unsplash.com"))
      return `${BACKEND}/api/img-proxy?url=${encodeURIComponent(url)}`;
    return url;
  }
  return `${BACKEND}${url}`;
};

export const retryImg = (e) => {
  const img = e.currentTarget;
  const n = Number(img.dataset.retry || 0);
  if (n >= 6) { img.dataset.failed = "1"; img.closest("[data-img-tile]")?.setAttribute("data-img-failed", "1"); return; }
  img.dataset.retry = n + 1;
  const src = img.getAttribute("src").split("&r=")[0];
  setTimeout(() => { img.removeAttribute("srcset"); img.src = `${src}&r=${n + 1}`; }, Math.min(1500 * 2 ** n, 20000));
};
export const imgLoaded = (e) => { const t = e.currentTarget.closest("[data-img-tile]"); if (t) { t.setAttribute("data-img-loaded", "1"); t.removeAttribute("data-img-failed"); } };
export const reloadImg = (e) => {
  e.stopPropagation();
  const t = e.currentTarget.closest("[data-img-tile]"); const img = t?.querySelector("img"); if (!img) return;
  t.removeAttribute("data-img-failed"); img.dataset.retry = 0;
  img.src = `${img.getAttribute("src").split("&r=")[0]}&r=${Date.now()}`;
};


export const thumbUrl = (url, w = 480) => {
  if (!url) return url;
  const i = url.indexOf("/api/files/");
  if (i >= 0) return `${BACKEND}/api/thumb/${url.slice(i + "/api/files/".length)}?w=${w}`;
  return fileUrl(url);
};

// Watermarked version of a stored proof image for customer-facing approval screens.
export const proofUrl = (url) => {
  if (!url) return url;
  const i = url.indexOf("/api/files/");
  if (i >= 0) return `${BACKEND}/api/proof/${url.slice(i + "/api/files/".length)}`;
  return fileUrl(url);
};

export default api;
